import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import i18n from '@/libs/i18n'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useDealersList() {
  // Use toast
  const toast = useToast()

  const refDealerListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'name', sortable: false, label: i18n.t('Dealer') },
    { key: 'document', sortable: false },
    { key: 'email', sortable: false },
    { key: 'manager', sortable: false },
    { key: 'managerEmail', sortable: false },
    { key: 'managerPhone', sortable: false },
   
    { key: 'actions' },
  ]
  


  const perPage = ref(10)
  const totalDealers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  
  const dataMeta = computed(() => {
    const localItemsCount = refDealerListTable.value ? refDealerListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDealers.value,
    }
  })

  const refetchData = () => {
    refDealerListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, ], () => {
    refetchData()
  })

  const fetchDealers = (ctx, callback) => {
    store
      .dispatch('app-dealer/fetchDealers', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        //role: roleFilter.value,
        //plan: planFilter.value,
        //status: statusFilter.value,
      })
      .then(response => {

        const dealers = response.data.data;
        const total = response.data.length;

        callback(dealers)
        totalDealers.value = response.data.totalItems
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('Error fetching dealers list'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  

  return {
    fetchDealers,
    tableColumns,
    perPage,
    currentPage,
    totalDealers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDealerListTable,

   
    refetchData,

    // Extra Filters
    //roleFilter,
    //planFilter,
    //statusFilter,
  }
}
